import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../../../app.service";
import { ListPageBase } from "../../../shared/components/list-page-base/list-page-base";
import { ServiceModeItem } from '../../../shared/models/services/service-mode-item';
import { StatePersistingService } from "../../../shared/services/state-persisting.service";
import { ServiceModesService } from '../../../shared/services/service-modes.service';
import { ExportExcelFromGridService } from "../../../shared/services/export-excel-from-grid.service";

@Component({
	selector: 'services-modes-list',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss']
})
export class ServiceModesListPage extends ListPageBase<ServiceModeItem> {

	constructor(
		protected appService: AppService,
		protected router: Router,
		protected dataService: ServiceModesService,
		protected persistingService: StatePersistingService,
		protected exportExcelFromGridService: ExportExcelFromGridService)
	{
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		appService.pageTitle = 'Режимы обслуживания';
	}

	onListPageInit(): void {

	}

	processListItems(items: ServiceModeItem[]): void {

	}

	public cellClick({ dataItem }: any): void {
		this.router.navigate(['/categories/service-mode', dataItem.id]);
	}

}
